import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5fbc98d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "practice-linked-practice" }
const _hoisted_2 = { class: "linked-practices-from" }
const _hoisted_3 = { class: "table-top" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "__left" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Status"),
  /*#__PURE__*/_createElementVNode("h2", null, "Linked practices (From)")
], -1))
const _hoisted_5 = { class: "__right" }
const _hoisted_6 = { class: "ls-table" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = ["colspan"]
const _hoisted_9 = { key: 1 }
const _hoisted_10 = ["colspan"]
const _hoisted_11 = { key: 2 }
const _hoisted_12 = ["colspan"]
const _hoisted_13 = { "data-label": "practiceName" }
const _hoisted_14 = { "data-label": "practiceBranchID" }
const _hoisted_15 = { "data-label": "latestTrustStatus" }
const _hoisted_16 = { "data-label": "Date" }
const _hoisted_17 = { "data-label": "Actions" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "linked-practices-to" }
const _hoisted_20 = { class: "table-top" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "__left" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Status"),
  /*#__PURE__*/_createElementVNode("h2", null, "Linked practices (To)")
], -1))
const _hoisted_22 = { class: "__right" }
const _hoisted_23 = { class: "ls-table" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = ["colspan"]
const _hoisted_26 = { key: 1 }
const _hoisted_27 = ["colspan"]
const _hoisted_28 = { key: 2 }
const _hoisted_29 = ["colspan"]
const _hoisted_30 = { "data-label": "practiceName" }
const _hoisted_31 = { "data-label": "practiceBranchID" }
const _hoisted_32 = { "data-label": "latestTrustStatus" }
const _hoisted_33 = { "data-label": "Date" }
const _hoisted_34 = { "data-label": "Actions" }
const _hoisted_35 = ["onClick"]

export function render(_ctx, _cache) {
  const _component_LoadingIndicator = _resolveComponent("LoadingIndicator")
  const _component_ErrorIndicator = _resolveComponent("ErrorIndicator")
  const _component_AddEditLinkedPracticeModal = _resolveComponent("AddEditLinkedPracticeModal")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            class: "btn btn-primary",
            onClick: _cache[0] || (_cache[0] = $event => (_ctx.openAddEditLinkedPracticeModal({id: 0}, 1)))
          }, "Transfer from")
        ])
      ]),
      _createElementVNode("table", _hoisted_6, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.linkedPracticesHeadings, (h, index) => {
              return (_openBlock(), _createElementBlock("th", null, [
                _createElementVNode("p", null, _toDisplayString(h.text), 1)
              ]))
            }), 256))
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_ctx.loadingContent)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_7, [
                _createElementVNode("td", {
                  colspan: _ctx.linkedPracticesHeadings.length
                }, [
                  _createVNode(_component_LoadingIndicator)
                ], 8, _hoisted_8)
              ]))
            : (_ctx.errorLoadingContent)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [
                  _createElementVNode("td", {
                    colspan: _ctx.linkedPracticesHeadings.length
                  }, [
                    _createVNode(_component_ErrorIndicator)
                  ], 8, _hoisted_10)
                ]))
              : (!_ctx.loadingContent && !_ctx.errorLoadingContent && _ctx.practicesFrom.length == 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_11, [
                    _createElementVNode("td", {
                      colspan: _ctx.linkedPracticesHeadings.length
                    }, "No Records", 8, _hoisted_12)
                  ]))
                : (!_ctx.loadingContent && !_ctx.errorLoadingContent && _ctx.practicesFrom.length > 0)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(_ctx.practicesFrom, (p) => {
                      return (_openBlock(), _createElementBlock("tr", null, [
                        _createElementVNode("td", _hoisted_13, _toDisplayString(p.branchId == null ? p.name :
                (p.name + ' (' + p.tradingName + ')')), 1),
                        _createElementVNode("td", _hoisted_14, _toDisplayString(p.branchId == null ?
                p.firmId : (p.firmId + ' - ' +
                p.branchId)), 1),
                        _createElementVNode("td", _hoisted_15, _toDisplayString(p.trustAccountStatus?.name), 1),
                        _createElementVNode("td", _hoisted_16, _toDisplayString(_ctx.$formatDate(p.linkedDate)), 1),
                        _createElementVNode("td", _hoisted_17, [
                          _createElementVNode("button", {
                            class: "btn btn-default sml",
                            onClick: $event => (_ctx.openAddEditLinkedPracticeModal(p, 1))
                          }, "Edit", 8, _hoisted_18)
                        ])
                      ]))
                    }), 256))
                  : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, [
        _hoisted_21,
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("button", {
            class: "btn btn-primary",
            onClick: _cache[1] || (_cache[1] = $event => (_ctx.openAddEditLinkedPracticeModal({id: 0}, 2)))
          }, "Transfer to")
        ])
      ]),
      _createElementVNode("table", _hoisted_23, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.linkedPracticesHeadings, (h, index) => {
              return (_openBlock(), _createElementBlock("th", null, [
                _createElementVNode("p", null, _toDisplayString(h.text), 1)
              ]))
            }), 256))
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_ctx.loadingContent)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_24, [
                _createElementVNode("td", {
                  colspan: _ctx.linkedPracticesHeadings.length
                }, [
                  _createVNode(_component_LoadingIndicator)
                ], 8, _hoisted_25)
              ]))
            : (_ctx.errorLoadingContent)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_26, [
                  _createElementVNode("td", {
                    colspan: _ctx.linkedPracticesHeadings.length
                  }, [
                    _createVNode(_component_ErrorIndicator)
                  ], 8, _hoisted_27)
                ]))
              : (!_ctx.loadingContent && !_ctx.errorLoadingContent && _ctx.practicesTo.length == 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_28, [
                    _createElementVNode("td", {
                      colspan: _ctx.linkedPracticesHeadings.length
                    }, "No Records", 8, _hoisted_29)
                  ]))
                : (!_ctx.loadingContent && !_ctx.errorLoadingContent && _ctx.practicesTo.length > 0)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(_ctx.practicesTo, (p) => {
                      return (_openBlock(), _createElementBlock("tr", null, [
                        _createElementVNode("td", _hoisted_30, _toDisplayString(p.branchId == null ? p.name :
                (p.name + ' (' + p.tradingName + ')')), 1),
                        _createElementVNode("td", _hoisted_31, _toDisplayString(p.branchId == null ?
                p.firmId : (p.firmId + ' - ' +
                p.branchId)), 1),
                        _createElementVNode("td", _hoisted_32, _toDisplayString(p.trustAccountStatus?.name), 1),
                        _createElementVNode("td", _hoisted_33, _toDisplayString(_ctx.$formatDate(p.linkedDate)), 1),
                        _createElementVNode("td", _hoisted_34, [
                          _createElementVNode("button", {
                            class: "btn btn-default sml",
                            onClick: $event => (_ctx.openAddEditLinkedPracticeModal(p, 2))
                          }, "Edit", 8, _hoisted_35)
                        ])
                      ]))
                    }), 256))
                  : _createCommentVNode("", true)
        ])
      ])
    ]),
    (_ctx.showLinkedPracticeModal)
      ? (_openBlock(), _createBlock(_component_AddEditLinkedPracticeModal, {
          key: 0,
          linkedPractice: _ctx.selectedLinkedPractice,
          practice: _ctx.selectedPractice,
          mode: _ctx.transferMode,
          onCloseAddEditLinkedPracticeModal: _cache[2] || (_cache[2] = $event => (_ctx.closeAddEditLinkedPracticeModal()))
        }, null, 8, ["linkedPractice", "practice", "mode"]))
      : _createCommentVNode("", true)
  ]))
}